export default __webpack_public_path__ + "static/media/change_password.2510d198.png";